module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18227/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp3.svg"